import { render, staticRenderFns } from "./InformationContainer.vue?vue&type=template&id=298df153&"
import script from "./InformationContainer.vue?vue&type=script&lang=ts&"
export * from "./InformationContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports